module.exports = __webpack_public_path__ + "img/contacts-hor.0f69a9a3.png";